import type { Rect } from '../../../engine/hex/types';
import type { IconRegistry } from '../../../ui/overlay/assets/IconRegistry';
import type { ModalTheme } from '../ModalTheme';
import type { HitTarget, MeasureResult, UiItem } from './Types';

export class DividerItem implements UiItem {
    private rect: Rect = { x: 0, y: 0, w: 0, h: 0 };

    constructor(
        private height: number,
        private color: string,
    ) {}

    measure(_ctx: CanvasRenderingContext2D, maxW: number, _theme: ModalTheme): MeasureResult {
        return { w: maxW, h: this.height };
    }

    layout(x: number, y: number, w: number, _theme: ModalTheme): void {
        this.rect = { x, y, w, h: this.height };
    }

    draw(ctx: CanvasRenderingContext2D, _theme: ModalTheme, _icons?: IconRegistry): void {
        ctx.fillStyle = this.color;
        ctx.fillRect(this.rect.x, this.rect.y, this.rect.w, this.rect.h);
    }

    collectHitTargets(_out: HitTarget[], _scrollY: number): void {}
}
